import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import css from './Label.css';
import QuestionMark from '../widgets/QuestionMark';

function Label({
    style = {},
    text = '',
    type = null,
    textReplace = {},
    mandatory = false,
    className = '',
    onClick = () => {},
    tooltip = '',
    tooltipClassName = '',
    tooltipIconName = '',
    icon: Icon = null,
    iconClassName = '',
    ...props
}) {
    return (
        <div
            className={classNames(css.container, css[type], className, { [css.mandatory]: mandatory })}
            style={style}
            onClick={onClick}
            {...props}
        >
            {Icon ? <Icon className={classNames(css.icon, iconClassName)} /> : null}
            <Translate id={text} data={textReplace} />
            {tooltip ? (
                <QuestionMark
                    containerClassName={classNames(css.tooltip, tooltipClassName)}
                    interactive
                    message={tooltip}
                    iconName={tooltipIconName || undefined}
                />
            ) : null}
        </div>
    );
}

Label.propTypes = {
    style: PropTypes.objectOf(PropTypes.any),
    mandatory: PropTypes.bool,
    text: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'shelfHeader',
        'p',
        'subtitle',
        'fieldLabel',
        'tableTd',
        'tableTh',
        'dialogTitle',
        'dialogBody',
        'sideLabel',
        'error',
        'header',
        null,
    ]),
    textReplace: PropTypes.objectOf(PropTypes.any),
    onClick: PropTypes.func,
    tooltipClassName: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipIconName: PropTypes.string,
    icon: PropTypes.func,
    iconClassName: PropTypes.string,
};

export default Label;
